import { SET_ATTENDANT_LIST } from "../actions/actios.types";

const INITIAL_STATE: any = {
  attendants: [],
};

const procedureReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case SET_ATTENDANT_LIST:
      return {
        ...state,
        attendants: action.attendants,
      };
    default:
      return state;
  }
};

export default procedureReducer;
